// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Accordion,
// } from "react-bootstrap";

// import EPCGimage from "../../assets/epcg-image.png";


// const faqData = [
//     {
//         q: "1. What does EPCG stand for and the benefit of an EPCG authorisation? ",
//         a: (
//             <p>
// EPCG stands for Export Promotion Capital Goods. The objective of this scheme is to facilitate the import of capital goods with the purpose of producing quality goods and services to enhance India’s export competitiveness. EPCG scheme allows the import of capital goods for pre-production, production, and post-production at zero customs duty.            </p>
//         ),
//     },
//   {
//     q:
//           "2. Who can benefit from the Export Promotion Capital Goods Scheme?",
//       a: (
//       <>
//         <p>YManufacturer exporters with or without supporting manufacturer(s), merchant exporters tied to supporting manufacturer(s) and service provider(s); and service providers. Refer to FTP and HBP for the latest details.</p>
       
//       </>
//     ),
//   },
//  {
//      q: "3. What are the requirements for applying for the Export Promotion Capital Goods Scheme?",
//              a: (
//                  <ul>
//                      <li>Your user profile must be linked with an IEC.</li>
//                      <li>A valid DSC / e-sign must be registered in the system. You may verify the same from My Dashboard  View and Register Digital Signature Token.</li>
//                      <li>GSTN details correspond to the branches of the IEC. The same may be added from Services  IEC Profile Management  Modify IEC.</li>
//                      <li>Valid RCMC details issued to the IEC.</li>
//         </ul>
//             ),
//     },
//  {
//         q: "The process if your IEC is in DEL/canceled/suspended?",
//         a: (
//             <p>
// If your IEC is in DEL, you shall be allowed to proceed with the submission of your request for issuance of an EPCG authorization, however, your application shall only be actioned upon once your IEC is removed from DEL.         </p>
//      ),
//   },
//   {
//       q: "5. What are the conditions to be fulfilled under the EPCG scheme?",
      
//         a: (
//             <>
//           <p> Refer to FTP and HBP for the latest details. The export obligation under the Export Promotion Capital Goods Scheme is required to be fulfilled by the export of goods/services rendered by you. There are two types of export obligations that the authorization holder is obligated to complete: </p>
      
//             <ul>
//                     <li>Annual average export obligation: The export obligation is over and above, the average level of export achieved by you as an authorisation holder in the preceding three licensing years for the same and similar products within the overall export obligation period including the extended period (if any). Such an average would be the arithmetic mean of export performance in the previous three years for the same and similar products.</li>
//                     <li>Specific export obligation: Specific export obligation is calculated as six times the duty saved amount. You must fulfill a minimum of 50% of export obligation in each block of years, i.e., the first block being the first 4 years and the second block is of the remaining 2 years. </li>
//             </ul>
//            </>
//       ),
//   },
//   {
//         q: "6. What items are allowed for import under the EPCG scheme?",
//       a: (
//             <>
//               <p>Capital Goods for the purpose of the EPCG scheme shall include:</p>
//               <ul>
//                   <li>Capital goods as defined in Chapter 9</li>
//                   <li>Computer systems and software which are a part of the capital goods</li>
//                   <li>Spares, molds, dies, jigs, fixtures, tools & refractories</li>
//                   <li>Catalysts for initial charge plus one subsequent charge</li>
//               </ul>

//             </>
//         ),
//   },
//   {
//         q: "7. Where can I check the status of my submitted application for EPCG?",
//         a: (

//             <>
//             <p>Please follow the below steps to check the status of a submitted application for EPCG</p>
//             <ul>
//                 <li>My Dashboard  Submitted Applications</li>
//                 <li>Enter the Type of Scheme (Select in the dropdown: Export Promotion Capital Goods (EPCG)) and Type of Sub Scheme (Issuance of EPCG Authorisation/Post-Export EPCG Authorisation)</li>
//                 <li>Click on Search</li>
//                 <li>In the search results, please find the status of the submitted application under the column File Status</li>
//             </ul>
// </>
//         ),
//   },
//   {
//         q: "8. How do I fulfill the export obligations under EPCG? ",
//         a: (
//           <p>You can export either directly or through a third party(s). Export proceeds are to be realized in freely convertible currency except for deemed exports. Import of capital goods imported under the EPCG scheme shall be subject to Actual user conditions until the export obligation is completed.</p>
//       ),
//   },
//   {
//         q: "9.  What is Post Export EPCG Duty Credit Scrip?",
//       a: (
//             <>
//               <p>Post Export EPCG Duty Credit scrip(s) shall be available to exporters who intend to import capital goods on full payment of applicable duties, taxes, and cess in cash and choose to opt for this scheme.</p>
//               <ul>
//                 <li>The basic customs duty paid on capital goods are remitted in the form of freely transferable duty credit scrip(s) under this scheme. This script shall be similar to that issued under Chapter 3 of FTP.</li>
//                 <li>The specific export obligation shall be 85% of the applicable specific export obligation under the EPCG scheme. However, the average export obligation shall remain unchanged.</li>
//                 <li>The duty remission shall be in proportion to the EO fulfilled.</li>
//                 <li>All provisions for utilization of the duty credit scrip(s) shall be applicable to Post Export EPCG Duty Credit Scrip(s) as under Chapter 3 of FTP.</li>
//                 <li>All provisions of the existing EPCG scheme shall apply in so far as they are not inconsistent with this scheme.</li>
//               </ul>
//               </>
//         ),
//     },
//   {
//         q: "10. What is the procedure to avail of benefits under the Post Export EPCG Duty Credit scheme? ",
//         a: (
//             <>
//                 <p>To avail of benefits under the Post Export EPCG Duty Credit Scrip, please follow the below steps:</p>
//                 <ul>
//                     <li>Services  EPCG</li>
//                     <li>Click on Apply for EPCG/Post Export EPCG authorization</li>
//                     <li>Now apply for the issuance of a post-export EPCG authorization by choosing Post Export EPCG under the Application for the field.</li>
//                     <li>Post issuance of the authorization, start with your exports against the authorization number issued to you.</li>
//                     <li>After completion of your exports, you may apply for the issuance of a Post Export Duty Credit Scheme by proceeding for Closure.</li>
//                 </ul>
//         </>
//                 ),
//   },
// ];

// export default function EPCG() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                         <div>

//                   <h1>Export Promotion Capital Goods Authorisation (EPCG licence)</h1>
//                                   <h2>What is the EPCG scheme?</h2>
//                                   <p>EPCG, the acronym for Export Promotion Capital Goods is a scheme that boosts the competitiveness of India's export by helping the country import quality capital goods to produce high quality goods and services.</p>
//                                 <p>The Export Promotion Capital Goods Scheme (EPCG) initiated by the Government of India is a part of the Foreign Trade Policy 2015-2020. The scheme allows the import of capital goods for pre-production, production, and post-production at 0% customs duty.</p>

//                                   <h2>Objectives of EPCG Scheme</h2>
//                                   <p>The objective of the EPCG (Export Promotion Capital Goods) Scheme is to accelerate the import of capital goods for producing high quality goods and services and enhance the country's manufacturing competitiveness.</p>
//                   </div>
//                  </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
            
//         <Row className="g-4 align-items-start">
//                           {/* LEFT CONTENT */}
//                       <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>Features of EPCG Scheme</h2>
//                                   <ul>
//                                       <li>Manufacturers or Merchant Exporters with supporting manufactures are allowed to import capital goods at 0% customs duty. The authorization holders to enjoy 0% customs duty need to undertake export obligation equivalent to 6 times the amount saved on taxes and duties on capital goods.</li>
//                                       <li>The imported capital goods cannot be sold or transferred until the export obligation is fulfilled.</li>
//                                       <li>The installation of capital goods should be done within 6 months from the date of imports.</li>
//                                       <li>The authorization holders need to file a bond with the customs before the import of capital goods with or without a bank guarantee.</li>
//                                       <li>The EPCG scheme doesn't cover second-hand goods</li>
//                                       <li>Exports filing to meet the export obligation have the privilege to take advantage of schemes under Chapter - 3 & Chapter - 4 also.</li>
//                                   </ul>

//                                   <h2>Export Obligations under EPCG Scheme</h2>
//                                   <ul>
//                                     <li>To avail of 0% customs duty under the EPCG Scheme, the authorization holder needs to fulfil the export obligation of 6 times of duty saved value in the span of 6 years.</li>
//                                     <li>Firstly, the authorized holder has to fulfill the export obligation for exporting goods or services on the issue of EPCG authorization.</li>
//                                     <li>The export obligation has to be more than the average export level achieved by the applicant in the past 3 licensing years for similar kinds of products.</li>
//                                   </ul>

//                                   <h2>Coverage of EPCG Scheme</h2>
//                                   <ul>
//                                     <li>Manufacturer exporters regardless of the presence of supporting manufacturer(s),</li>
//                                     <li>Merchant exporters linked with supporting manufacturers and service providers.</li>
//                                     <li>The scheme also covers service providers who are certified as CSP (Common Service Provider) by the DGFT, State Industrial Infrastructure Corporation or Department of Commerce in subject to provisions and conditions of Foreign Trade Policy 2015-2020.</li>
//                                     <li>Supporting manufacturers shall be endorsed on the EPCG Authorization before installing capital goods in the factory.</li>
//                                   </ul>

//                                   <h2>Application Form</h2>
//                                   <ul>
//                                     <li>You can apply for the scheme by selecting the head office or registered office, or manufacturing unit or branch office of an eligible exporter to RA concerned in ANF 5A with the documents mentioned.</li>
//                                     <li>RA concerned shall issue EPCG authorization on the basis of the nexus certificate submitted by the applicant is Appendix 5A.</li>
//                                   </ul>
//                                   <p>No time to register yourself under the EPCG scheme? Look for the best EPCG consultants who can take your job. We, Apex, is the most trusted EPCG consultants that can make your job easier and help you start your business in no time. Get in touch!</p>
                        
//                                   <h2>Eligibility of Capital Goods Under EPCG Scheme</h2>
//                                   <p>Let's have a look at the list of capital goods eligible for 0% customs duty.</p>
//                                   <p>Any equipment, accessories, plant, or machinery needed for production or manufacturing or rendering services come under capital goods. Eligible capital goods under the EPCG scheme are:</p>
//                                   <ul>
//                                       <li>Any machinery, accessories, plant or equipment. This includes packaging equipment, machinery, machine tools, refrigeration equipment, instruments, equipment needed for R&D, testing, pollution control and quality.</li>
//                                       <li>Dies, tools, spares, fixtures, jigs, moulds and refractories to use in the initial lining.</li>
//                                       <li>Catalysts for the charge.</li>
//                                   </ul>
//                                   <p>Capital Goods that are not eligible for EPCG Scheme are:</p>

//                                   <img src={EPCGimage} alt="EPCG Scheme" className="img-fluid d-block mx-auto mb-3" />
                             
//                              <p>Thus the beneficial scheme allows you to enjoy duty free import of capital goods. Looking for the best EPCG Licensing Consulting Services in Hyderabad? We are one of the best EPCG consultants with a team that has decades of experience in the industry. We provide valued and flexible DGFT and industrial subsidy services to make the business easier for you. Talk to us and let us understand your needs before we deliver our smooth services.</p>
                             
//                                   <h2>At Apex  What We Do</h2>
//                                   <p>At Apex Professional Services, we give you a detailed explanation explaining the terms and conditions of the EPCG scheme concerning export obligation. This will prevent you from making any future mistakes. We help you in preparing documentation for the EPCG License application. The license is obtained from the Director General of Foreign Trade. Furthermore, there is guidance in the requirement and compliance followed by the Clients once the authorization is issued. Getting Redemption Letter from DGFT RA and release of Bond/BG after fulfilling the export obligation from Customs.</p>
//                               </div>

//     </Col>
//             </Row>
//             </Container>
//         </section>
        

//         {/* ===== FAQ SECTION ===== */}
//          <section className="py-5 bg-light faq-section">
//                   <Container>
//                       <h2 className="text-center mb-4">Frequently Asked Questions on Importer-Exporter Code (IEC)/(E-IEC)</h2>
//             <Accordion defaultActiveKey="0" className="custom-faq">
//                         {faqData.map((f, i) => (
//                           <Accordion.Item eventKey={String(i)} key={i}>
//                             <Accordion.Header>{f.q}</Accordion.Header>
//                             <Accordion.Body>{f.a}</Accordion.Body>
//                           </Accordion.Item>
//                         ))}
//                       </Accordion>
//                     </Container>
//                     </section>
//                   </div>
//                   </>
//   );
// }


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaHandsHelping
} from "react-icons/fa";
import { Accordion } from "react-bootstrap";

export default function EPCG() {
  const faqData = [
  {
    q: "What is EPCG Scheme?",
    a: "EPCG (Export Promotion Capital Goods) Scheme allows import of capital goods at zero or concessional customs duty to promote exports and improve manufacturing capability.",
  },
  {
    q: "Who can apply for EPCG license?",
    a: "Manufacturer exporters, merchant exporters with supporting manufacturers, and service providers notified under Foreign Trade Policy can apply for EPCG.",
  },
  {
    q: "What is export obligation under EPCG?",
    a: "Export obligation is usually 6 times the duty saved on imported capital goods and must be fulfilled within 6 to 8 years.",
  },
  {
    q: "What goods are covered under EPCG?",
    a: "Capital goods such as machinery, equipment, tools, and technology required for production, quality improvement, or service delivery are covered.",
  },
  {
    q: "Is EPCG license transferable?",
    a: "No, EPCG license is non-transferable and capital goods imported under the scheme must be used by the license holder.",
  },
  {
    q: "Can second-hand machinery be imported under EPCG?",
    a: "Generally, second-hand goods are restricted unless specifically allowed under DGFT guidelines.",
  },
  {
    q: "What happens if export obligation is not fulfilled?",
    a: "Failure to fulfill export obligation may result in payment of duty saved along with interest and penalties.",
  },
  {
    q: "Is GST applicable under EPCG?",
    a: "IGST benefits may be available under EPCG, depending on current government notifications and policies.",
  },
  {
    q: "How long does it take to get EPCG license?",
    a: "EPCG license is usually issued within a few working days after successful application and verification.",
  },
  {
    q: "Can exports be done through third parties?",
    a: "Yes, exports can be fulfilled directly or through third-party exporters, subject to DGFT conditions.",
  },
];
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">

            <Col lg={8}>
              <h1>
                Export Promotion Capital Goods (EPCG) License
              </h1>

              <p>
                The EPCG (Export Promotion Capital Goods) Scheme is a flagship
                initiative by the Government of India that allows businesses to
                import capital goods at zero or concessional customs duty.
              </p>

              <p>
                It helps exporters upgrade technology, improve production
                capacity, and enhance global competitiveness while fulfilling
                specified export obligations.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your assistance section here */}
            </Col>

          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of EPCG Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Import advanced machinery and technology</li>
            <li><FaCheckCircle /> Improve product quality and efficiency</li>
            <li><FaCheckCircle /> Reduce manufacturing costs</li>
            <li><FaCheckCircle /> Strengthen export competitiveness</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligibility for EPCG License
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Manufacturer exporters</li>
            <li><FaCheckCircle /> Merchant exporters with supporting manufacturers</li>
            <li><FaCheckCircle /> Service providers under Foreign Trade Policy</li>
          </ul>

          {/* EXPORT OBLIGATION */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Export Obligation
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Obligation period: 6 to 8 years</li>
            <li><FaCheckCircle /> Typically 6 times the duty saved amount</li>
            <li><FaCheckCircle /> Must comply to avoid penalties</li>
            <li><FaCheckCircle /> Minimum export targets in defined blocks</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits of EPCG Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Duty-free or concessional import of capital goods</li>
            <li><FaCheckCircle /> Access to global technology</li>
            <li><FaCheckCircle /> Increased production capacity</li>
            <li><FaCheckCircle /> Better global market competitiveness</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Business eligibility assessment</li>
            <li><FaCheckCircle /> Documentation and application filing</li>
            <li><FaCheckCircle /> DGFT verification process</li>
            <li><FaCheckCircle /> License issuance</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide end-to-end EPCG support including
            eligibility assessment, documentation, application filing, and
            post-license compliance. We also assist in export obligation tracking
            and ensure smooth and timely approvals.
          </p>


          <h2 className="section-title mt-4">Frequently Asked Questions</h2>

<Accordion defaultActiveKey="0">
  {faqData.map((f, i) => (
    <Accordion.Item eventKey={String(i)} key={i}>
      <Accordion.Header>{f.q}</Accordion.Header>
      <Accordion.Body>{f.a}</Accordion.Body>
    </Accordion.Item>
  ))}
</Accordion>

        </Container>
      </section>
    </div>
  );
}